import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import Order from "@/pages/Order";

export const Route = createFileRoute("/_public/order/")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Order a Fence or Gate \u2014 Secure Your Project with a 50% Deposit", "Price a fence or standalone gate, check project eligibility and reserve with a secure 50% deposit. Existing-fence tune-ups have their own checkout.", "/order", false),
  component: Order,
});
